import IPlantProtectionSummary = Data.TaskManagement.IPlantProtectionSummary;
import IGuid = System.IGuid;
import IPlantProtectionPlanBook = Data.TaskManagement.IPlantProtectionPlanBook;

export const PpNoDataValue = -999;

export interface IPpPlanningBookingGridItem {
  Id: IGuid;
  Summary: IPlantProtectionSummary;
  Status: number;
  StatusClass: string;
  StatusDesc: string;
  FieldIds: IGuid[];
  Count: string;
  Crop: string;
  CropId: any;
  Appl: string;
  ApplSum: number;
  Area: number;
  OperationMode: string;
  OperationModeKey: string;
  OperationModeKeyTrans: string;
  ProductNames: string;
  ProductNamesTooltip: string;
  ProductsSum: string;
  ProductsSumTooltip: string;
  ApplUnit: string;
  Avg: number;
  Min: number;
  Max: number;
  NUptakeAverage: number;
  ApplicationDate: Date;
  ApplicationDateTooltip: string;
  ApplicationDateItalic: boolean;
  Note: string;
  PlanBooks: IPlantProtectionPlanBook[];
  FieldsTooltip: string;
}

export interface ISummaryWithPlanBooks {
  Summary: IPlantProtectionSummary;
  FilteredPlanBooks: IPlantProtectionPlanBook[];
  TotalPlanBooks: IPlantProtectionPlanBook[];
}
